import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';
import { convertMidRelatedRecommendGoodsItemToGoodsData } from '../utils/convertMidRelatedGoodsItemToGoodsData';

export const useMidRelatedRecommendGoodsList = () => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.goodsMidRelatedRecommend(goodsSno),
    queryFn: () => goodsService.getMidRelatedAdGoods(goodsSno),
    select: data => {
      return {
        ...data,
        item_list: data.item_list.map(
          convertMidRelatedRecommendGoodsItemToGoodsData,
        ),
      };
    },
  });
};
